import { useLocale } from '../i18n/locale';
import { sectionId } from '../content/site';
import { HOME } from './content';

/**
 * COLESCOMEX SUPPLY: the integrated capabilities one operation activates — a compact editorial band
 * that opens "how we operate" (capabilities, not separate products).
 */
export function Supply() {
  const { locale } = useLocale(); const copy = HOME[locale].supply;
  return (
    <section id={sectionId('operate', locale)} className="supply" data-tone="light" aria-labelledby="supply-title">
      <div className="supply__inner wrap">
        <div className="supply__intro">
          <h2 id="supply-title" className="supply__label">{copy.label}</h2>
          <p className="supply__line">{copy.line}</p>
        </div>
        <ul className="supply__list" role="list">
          {copy.capabilities.map(capability => <li key={capability}>{capability}</li>)}
        </ul>
      </div>
    </section>
  );
}
